import script from "./AddExternalUsersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddExternalUsersModal.vue?vue&type=script&setup=true&lang=js"

import "./AddExternalUsersModal.vue?vue&type=style&index=0&id=75515775&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75515775"]])

export default __exports__